import GoPage from './GoPage'

export default GoPage
// eslint-disable-next-line import/export
export * from './GoPage'
